import * as ACTION_TYPES from "../actions/action-types";

const initialState = {
  taskBookmarks: [],
  projectBookmarks: [],
  queueBookmarks: [],
  libraryBookmarks: [],
  favouriteFilters: [],
};

/**
 * setting states according to the type of actions
 * @param {*} state
 * @param {*} action
 * @returns {state}
 */

const bookmarks = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.GET_TASK_BOOKMARKS:
      return {
        ...state,
        taskBookmarks: payload,
      };
    case ACTION_TYPES.GET_PROJECT_BOOKMARKS:
      return {
        ...state,
        projectBookmarks: payload,
      };
    case ACTION_TYPES.GET_QUEUE_BOOKMARKS:
      return {
        ...state,
        queueBookmarks: payload,
      };
    case ACTION_TYPES.GET_LIBRARY_BOOKMARKS:
      return {
        ...state,
        libraryBookmarks: payload,
      };
    case ACTION_TYPES.SET_FAVOURITE_FILTERS:
      return {
        ...state,
        favouriteFilters: payload,
      };
    default:
      return state;
  }
};

export default bookmarks;
